"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = void 0;
const React = require("react");
const react_intl_1 = require("react-intl");
const reactstrap_1 = require("reactstrap");
const Line = (props) => (React.createElement(reactstrap_1.FormGroup, { className: props.className }, props.inline ? (React.createElement(reactstrap_1.Row, null,
    React.createElement(reactstrap_1.Col, { xs: props.inline === true ? '3' : props.inline }, props.title && (React.createElement(reactstrap_1.Label, { for: props.field },
        React.createElement(react_intl_1.FormattedMessage, { id: props.title })))),
    React.createElement(reactstrap_1.Col, { xs: props.inline === true ? '9' : 12 - props.inline }, props.children))) : (React.createElement(React.Fragment, null,
    props.title && (React.createElement(reactstrap_1.Label, { for: props.field },
        React.createElement(react_intl_1.FormattedMessage, { id: props.title }))),
    props.children))));
exports.Line = Line;
